
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type TrendItemContentTweetsItemMediaLinksItemLinkType = typeof TrendItemContentTweetsItemMediaLinksItemLinkType[keyof typeof TrendItemContentTweetsItemMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendItemContentTweetsItemMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
